import { useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { Clock, Pencil, X, Check } from "lucide-react";

const fmt = (iso) => iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }) : "—";
const toLocal = (iso) => { const d = new Date(iso); const p = (n) => String(n).padStart(2, "0"); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`; };

// Closed-time line with an EDIT control: dispatcher/supervisor can correct the effective close
// time when a unit cleared before the call was actually closed. Logged as a correction.
export const ClosedTimeEditor = ({ incident, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  if (incident?.status !== "closed" || !incident.closed_at) return null;
  const corrected = incident.closed_at_recorded && incident.closed_at_recorded !== incident.closed_at;
  const save = async () => {
    if (!val || !reason.trim()) { toast.error("Time and reason are required"); return; }
    setBusy(true);
    try {
      await client.post(`/incidents/${incident.id}/closed-time`, { closed_at: new Date(val).toISOString(), reason: reason.trim() });
      toast.success("Close time corrected — logged in event log"); setEdit(false); setReason(""); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not update close time"); }
    setBusy(false);
  };
  return (
    <div data-testid="closed-time-line" className="font-mono text-[11px] text-[#9CA3AF] flex flex-wrap items-center gap-2">
      <Clock size={12} className="text-[#6B7280]" />
      <span>Closed <span className="text-white" data-testid="closed-time-value">{fmt(incident.closed_at)}</span></span>
      {corrected && <span className="text-[#F59E0B]" title={`System recorded close: ${fmt(incident.closed_at_recorded)} · corrected by ${incident.closed_at_corrected_by || ""}`}>· corrected (recorded {fmt(incident.closed_at_recorded).slice(-5)})</span>}
      {!edit
        ? <button data-testid="closed-time-edit" onClick={() => { setVal(toLocal(incident.closed_at)); setEdit(true); }} className="flex items-center gap-1 px-1.5 py-0.5 border border-[#2C2D35] text-[#9CA3AF] hover:text-white hover:border-[#3B82F6] text-[10px] font-head font-bold"><Pencil size={10} /> EDIT TIME</button>
        : (
          <span className="flex flex-wrap items-center gap-1.5">
            <input data-testid="closed-time-input" type="datetime-local" value={val} onChange={(e) => setVal(e.target.value)} max={toLocal(new Date().toISOString())} min={incident.created_at ? toLocal(incident.created_at) : undefined}
              className="bg-[#141518] border border-[#3B82F6] px-2 py-1 text-[11px] font-mono text-white outline-none" />
            <input data-testid="closed-time-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (e.g. unit cleared 21:14, closed late)"
              className="bg-[#141518] border border-[#2C2D35] px-2 py-1 text-[11px] font-mono text-white outline-none w-72" />
            <button data-testid="closed-time-save" onClick={save} disabled={busy} className="px-2 py-1 bg-[#3B82F6] text-white text-[10px] font-head font-bold flex items-center gap-1 disabled:opacity-50"><Check size={10} /> SAVE</button>
            <button onClick={() => setEdit(false)} className="text-[#9CA3AF] hover:text-white"><X size={12} /></button>
          </span>
        )}
    </div>
  );
};
